import React, { Fragment } from "react";

class StatusModal extends React.Component {
  state = { buttonStyle: "fill" };
  render() {
    return (
      <Fragment>
        <div
          className={
            this.props.modal === "opened"
              ? "clickable-input-area opened"
              : "clickable-input-area closed"
          }
          onClick={e => this.props.handleOpenClose(e)}
        />
        <div
          className={
            (this.props.modal === "opened"
              ? `status-modal opened ${this.props.action}`
              : `status-modal closed ${this.props.action}`) +
            ` ${
              this.props.msg &&
              this.props.msg.content &&
              this.props.msg.props.content.length > 6
                ? this.props.msg.props.content.length > 12
                  ? "col3"
                  : "col2"
                : "col1"
            }`
          }
        >
          <div className="body">
            {/* <select
              name="buttonstyle"
              onChange={e => this.setState({ buttonStyle: e.target.value })}
            >
              <option value="fill">orange-fill</option>
              <option value="bordered">orange-border</option>
            </select> */}
            {/* <div className='title'>
              <i className="material-icons icon1">{this.props.icon}</i>
              <i className="material-icons icon2">{this.props.icon}</i>
              <p>{this.props.title}</p>
              
            </div> */}
            <div className="message">
              <div className="message text">{this.props.msg}</div>
            </div>
            <div className="actions">
              {this.props.hasOnlyClose ? (
                <div
                  className={`modal-button ${this.state.buttonStyle}`}
                  onClick={e => this.props.handleOpenClose(e)}
                >
                  {this.props.buttonText ? this.props.buttonText : "OK"}
                </div>
              ) : (
                <Fragment>
                  {this.props.noReturn ? null : (
                    <div
                      className={`modal-button ${this.state.buttonStyle}`}
                      onClick={e => this.props.handleOpenClose(e)}
                    >
                      {"Return"}
                    </div>
                  )}
                  {this.props.buttonText ? (
                    <div
                      className={`modal-button ${this.state.buttonStyle}`}
                      onClick={e => this.props.buttonActions.button1(e)}
                    >
                      {this.props.buttonText}
                    </div>
                  ) : null}

                  {this.props.active ? (
                    <div
                      className={`modal-button ${this.state.buttonStyle}`}
                      onClick={e => this.props.buttonActions.button2(e)}
                    >
                      {this.props.buttonText2 ? this.props.buttonText2 : "OK"}
                    </div>
                  ) : (
                    <div
                      className={`modal-button ${
                        this.state.buttonStyle
                      } inactive`}
                      onClick={e => this.props.buttonActions.button2(e)}
                    >
                      {this.props.buttonText2 ? this.props.buttonText2 : "OK"}
                    </div>
                  )}
                </Fragment>
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}
export default StatusModal;
